export default __webpack_public_path__ + "static/media/IPA_PL.fac34a9b.png";